import { useEffect, useState } from 'react'
import { clientSessionViewStore } from '../../../services/clientSessionViewStore.js'
import {
  createFreshClientSessionId,
  getOrCreateClientSessionId,
} from '../../core/session/session-identity.js'
import { hasFreshSessionQuery } from '../../lib/visitor-session-isolation.js'

function readInitialSessionId(): string {
  if (typeof window !== 'undefined') {
    if (hasFreshSessionQuery(window.location.search)) {
      return createFreshClientSessionId()
    }
  }

  return getOrCreateClientSessionId()
}

export function useSessionId(): string {
  const [sessionId, setSessionIdState] = useState<string>(readInitialSessionId)

  useEffect(() => {
    clientSessionViewStore.setSessionId(sessionId)
  }, [sessionId])

  useEffect(() => {
    const unsubscribe = clientSessionViewStore.subscribe(state => {
      if (state.sessionId && state.sessionId !== sessionId) {
        setSessionIdState(state.sessionId)
      }
    })
    return () => {
      unsubscribe()
    }
  }, [sessionId])

  return sessionId
}
